import { gql } from "gql";

export const SAVE_COMPANY_DOCUMENT_FOLDER = gql(/* GraphQL */ `
  mutation SaveCompanyDocumentFolder($folder: CompanyDocumentFolderInput!) {
    saveCompanyDocumentFolder(folder: $folder) {
      id
    }
  }
`);
